var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "24px",
    viewBox: "0 0 40 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L37,0 C38.6568542,-3.04359188e-16 40,1.34314575 40,3 L40,4 L0,4 L0,3 C-2.02906125e-16,1.34314575 1.34314575,3.04359188e-16 3,0 Z",
    id: "Rectangle",
    fill: "#1A1F71",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,20 L37,20 C38.6568542,20 40,21.3431458 40,23 L40,24 L0,24 L0,23 C-2.02906125e-16,21.3431458 1.34314575,20 3,20 Z",
    id: "Rectangle-Copy",
    fill: "#F7B600",
    fillRule: "nonzero",
    transform: "translate(20.000000, 22.000000) scale(-1, 1) rotate(-180.000000) translate(-20.000000, -22.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,0.5 L37.5,0.5 C38.60457,0.5 39.5,1.3954305 39.5,2.5 L39.5,21.5 C39.5,22.60457 38.60457,23.5 37.5,23.5 L2.5,23.5 C1.3954305,23.5 0.5,22.60457 0.5,21.5 L0.5,2.5 C0.5,1.3954305 1.3954305,0.5 2.5,0.5 Z",
    id: "Stroke-14",
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.10133,6.89984 L10.78863,16.952577 L7.967742,16.952577 L5.852078,8.9157 C5.716459,8.41173 5.607963,8.25259 5.228228,8.04039 C4.392576,7.64708 3.508147,7.36176 2.59721,7.19161 L2.651458,6.89984 L7.181149,6.89984 C7.793428,6.90255 8.311965,7.34201 8.401724,7.93429 L9.513804,13.74313 L12.28044,6.89984 L15.10133,6.89984 Z",
    id: "Path",
    fill: "#1A1F71",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.14075,13.66356 C26.11363,15.758981 24.29633,17.111723 21.50257,17.085199 C20.49068,17.103759 19.48529,16.923362 18.54606,16.554712 L19.03429,14.35319 C19.8748,14.796073 20.81941,15.015574 21.77381,14.989774 C22.53328,14.989774 23.37412,14.671482 23.37412,14.008373 C23.37412,13.58398 22.99438,13.23917 21.9908,12.76173 C20.98721,12.28429 19.63102,11.48856 19.65814,10.02972 C19.68527,8.09344 21.52969,6.71417 24.16071,6.71417 C25.01378,6.71318 25.85973,6.86604 26.65611,7.16509 L26.195,9.28704 C25.37499,8.90943 24.46644,8.75372 23.56398,8.83612 C22.77739,8.94222 22.42478,9.31356 22.42478,9.6849 C22.39766,10.85197 26.14075,11.01112 26.14075,13.66356 Z",
    id: "Path",
    fill: "#1A1F71",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.08447,16.952577 L32.73186,15.440689 L29.31425,15.440689 L28.77177,16.952577 L25.97801,16.952577 L29.99235,7.64253 C30.17913,7.18892 30.63153,6.89399 31.13155,6.89984 L33.40996,6.89984 L35.55275,16.952577 L33.08447,16.952577 Z M30.10084,13.39831 L32.325,13.39831 L31.51129,9.63185 L30.10084,13.39831 Z",
    id: "Combined-Shape",
    fill: "#1A1F71",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1A1F71",
    fillRule: "nonzero",
    points: "18.89867 6.89984 16.70164 16.952577 14.0435 16.952577 16.24053 6.89984"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.6ded16c68d1af25fd456ed66c8ca23ed.svg";
export { ForwardRef as ReactComponent };